export default __webpack_public_path__ + "static/blu-sky-aaaaca26ce59ee07d06b4e107d17415e.jpg";